import { DataQuoteStateType } from "../typesCollapseQuote";
import * as S from "./styles";
import ColumnLabel from "@/main/components/common/columnLabel/columnLabel";
import { getGuidScreenByRoute, getTranslateByKey, isNullUndefined } from "@/main/services/utils";
import { getRefreshForceUrl } from "@/main/services/utilsQueryParams";
import { useNavigate } from "react-router-dom";
import KogThreeDotsQuote from "@/main/components/shared/threeDotsQuote";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { RefreshQuoteByGetItemsType } from "@/main/components/shared/boxCart/components/types";
import { CartState } from "@/main/store/cart";
import CopyToClipboardText from "@/main/components/shared/copyToClipboardText/copyToClipboardText";
import useKogControlElementId from "@/main/hooks/useKogControlElementId";
import { Controls } from "@/main/services/constants/constantsControl";
import { userIsSupplier } from "@/main/services/utilsUser";
import TotalLossComponent from "@/main/components/shared/totalLossComponent/totalLossComponent";

interface IHeaderCollapseQuoteProps {
	dataQuote: DataQuoteStateType;
	dataCart: CartState;
	canShowButtonRemovePart: boolean;
	loadCart: (guidQuote: string) => void;
	getDetailsQuote: (guidQuote: string) => void;
	refreshQuoteByGetItems: RefreshQuoteByGetItemsType;
	guidClaim: string;
	vehicleName?: string;
	orderNumber?: string;
}
function HeaderCollapseQuote({
	dataQuote,
	dataCart,
	canShowButtonRemovePart,
	loadCart,
	getDetailsQuote,
	refreshQuoteByGetItems,
	guidClaim,
	vehicleName,
	orderNumber,
}: IHeaderCollapseQuoteProps) {
	const navigate = useNavigate();
	const showPartTypeControl = useKogControlElementId(Controls.IdSearchProcurementRequotePartType);
	const canDownloadImages = useKogControlElementId(Controls.IdDownloadImagesSearchOrdersControl);

	if (isNullUndefined(dataQuote)) return null;

	const isQuoteCanceled = dataQuote.idProcurementStatus === ProcurementStatusEnum.Cancelled;
	const isQuoteManual = dataQuote.idProcurementStatus === ProcurementStatusEnum.Manual;
	const isWaitingRelease = dataQuote.idProcurementStatus === ProcurementStatusEnum.WaitingRelease;
	const isOpen = dataQuote.idProcurementStatus === ProcurementStatusEnum.Open;
	const guidQuote = dataQuote.guid;
	const claimNumber = dataQuote.claimNumber;
	const hasOrderByClaim = dataQuote.hasOrderByClaim;
	const showTotalLoss = !userIsSupplier();
	const hideActionsForSupplier = userIsSupplier() && isWaitingRelease;

	return (
		<S.Container>
			<ColumnLabel
				label={getTranslateByKey("information.vin")}
				content={
					<CopyToClipboardText
						label={getTranslateByKey("information.vin")}
						valueToCopy={dataQuote.vehicleVIN ? dataQuote.vehicleVIN : ""}
					>
						{dataQuote.vehicleVIN}
					</CopyToClipboardText>
				}
			/>
			{showTotalLoss && (
				<TotalLossComponent type="column" idStatus={dataQuote.idProcurementStatus} guidQuote={guidQuote} />
			)}

			<S.AreaAbsoluteInfoQuote>
				<KogThreeDotsQuote.Root>
					<KogThreeDotsQuote.OptionImage
						guidQuote={guidQuote}
						guidClaim={guidClaim}
						isQuoteCanceled={isQuoteCanceled}
						canDownloadImages={canDownloadImages}
					/>
					<KogThreeDotsQuote.OptionHistory
						guidQuote={guidQuote}
						guidScreen={getGuidScreenByRoute(RoutesConstants.orderSearchOrder)}
					/>
					<KogThreeDotsQuote.OptionHasOrderByClaim claimNumber={claimNumber} hasOrderByClaim={hasOrderByClaim} />
					<KogThreeDotsQuote.OptionRequoteParts
						dataCart={dataCart}
						setIsQuoteBlocked={() => {}}
						loadCart={loadCart}
						guidQuote={String(guidQuote)}
						loadInfoOrder={getDetailsQuote}
						refreshQuoteByGetItems={refreshQuoteByGetItems}
						numbersParts={dataCart.cartItems.data.length}
						showButtonRemoveBulkPart={!isWaitingRelease && !isOpen}
						showPartTypeControl={showPartTypeControl}
					/>
					{canShowButtonRemovePart && dataQuote.idProcurementStatus !== ProcurementStatusEnum.WaitingRelease && (
						<KogThreeDotsQuote.OptionCancelParts
							guidQuote={String(guidQuote)}
							dataCart={dataCart}
							refreshQuoteByGetItems={refreshQuoteByGetItems}
							numbersParts={dataCart.cartItems.data.length}
							showButtonRemoveBulkPart={true}
							isQuoteCanceled={isQuoteCanceled}
						/>
					)}
					{!hideActionsForSupplier && (
						<KogThreeDotsQuote.OptionDirectAssign
							guidCompanyBuyer={dataQuote.guidCompanyBuyer}
							guidCountry={dataQuote.guidCountry}
							guidQuote={guidQuote}
							guidClaim={guidClaim}
							isQuoteManual={isQuoteManual}
							canDownloadImages={canDownloadImages}
							onSuccess={() => {
								loadCart(guidQuote);

								const filters = getRefreshForceUrl({
									quoteFilterVehicle: claimNumber,
								});
								const routeRedirect = `${RoutesConstants.orderSearchOrder}${filters}`;
								navigate(routeRedirect);
							}}
						/>
					)}
					<KogThreeDotsQuote.OptionSendUpdates
						guidClaim={guidClaim}
						isAwaitingRelease={isWaitingRelease}
						guidQuote={guidQuote}
					/>
					<KogThreeDotsQuote.OptionViewVouchers
						guidInsurer={dataQuote?.guidCompanyBuyer}
						reportNumber={claimNumber}
						orderNumber={orderNumber}
						vehicleName={vehicleName ?? dataQuote?.vehicleVIN}
						quoteNumber={dataQuote?.code?.toString()}
					/>
				</KogThreeDotsQuote.Root>
			</S.AreaAbsoluteInfoQuote>
		</S.Container>
	);
}

export default HeaderCollapseQuote;
